/* eslint-disable */
export default class Helper {
  /**
   * waits for a certain amount of time
   * @param {int} ms
   */
  static timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /**
   * returns a string of ids of objects seperated by comma
   * @param {*} objects
   */
  static getIdsString(objects) {
    let alreadyInString = [];
    let string = "";
    objects.forEach((object, index) => {
      if (!alreadyInString.includes(object)) {
        alreadyInString.push(object);
        string += object.id;
        if (index < objects.length - 1 && objects.length > 1) {
          string += ",";
        }
      }
    });
    return string;
  }

  /**
   * opens pdf file
   * @param {*} vue instnace
   * @param {string} pdf pdf link
   * @param {boolean} reload do we want to reload page
   */
  static async openPdf(vue, pdf, reload) {
    if (pdf != null) {
      await Helper.timeout(50);
      window.open(pdf, "_blank");
      vue.pdf = null;
      if (reload) {
        vue.$router.go();
      }
    }
  }

  /**
   * gets string placeholder without same values
   * @param {*} current
   * @param {*} addition
   */
  static getSettingPlaceholder(current, addition) {
    const parts = current.split(" ");
    const additionPart = addition != null ? `${addition}`.split(" ") : [];
    additionPart.forEach(addition => {
      if (!parts.includes(`${addition.trim()}`)) {
        current += addition.trim() + " ";
      }
    });
    return current;
  }

  static getLocale(vue) {
    switch (vue.$router.currentRoute.params.lang) {
      case "lt":
        return "lt-LT";
      case "en":
        return "en-GB";
      default:
        return "en-GB";
    }
  }

  /**
   * groups object by specified key
   * @param {Object} xs
   * @param {String} key
   */
  static groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  static isMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  /**
 * draws pallet base
 * @param ctx - canvas context
 * @param fromX
 * @param fromY
 * @param toX
 * @param toY
 */
  static canvasArrow(ctx, fromX, fromY, toX, toY) {
    let headlen = 10; // length of head in pixels
    let angle = Math.atan2(toY - fromY, toX - fromX);
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    ctx.lineTo(
      toX - headlen * Math.cos(angle - Math.PI / 6),
      toY - headlen * Math.sin(angle - Math.PI / 6)
    );
    ctx.moveTo(toX, toY);
    ctx.lineTo(
      toX - headlen * Math.cos(angle + Math.PI / 6),
      toY - headlen * Math.sin(angle + Math.PI / 6)
    );
    ctx.stroke();
  }


  static getDate(date) {
    const newDate = new Date(date);
    if (newDate == "Invalid Date") {
      return null;
    }
    const year = new Intl.DateTimeFormat("lt", { year: "numeric" }).format(
      newDate
    );
    const month = new Intl.DateTimeFormat("lt", { month: "short" }).format(
      newDate
    );
    const day = new Intl.DateTimeFormat("lt", { day: "2-digit" }).format(
      newDate
    );
    if (newDate.getTime() == new Date("1970-01-01").getTime()) {
      return "";
    }
    return `${year}-${month}-${day}`;
  }

  static joystick(e, object, props) {
    if (e.key == "ArrowLeft") {
      e.preventDefault();
      object[props[0]] = parseInt(object[props[0]]) - 1;
    }
    if (e.key == "ArrowRight") {
      e.preventDefault();
      object[props[0]] = parseInt(object[props[0]]) + 1;
    }
    if (e.key == "ArrowUp") {
      e.preventDefault();
      object[props[1]] = parseInt(object[props[1]]) - 1;
    }
    if (e.key == "ArrowDown") {
      e.preventDefault();
      object[props[1]] = parseInt(object[props[1]]) + 1;
    }
    if (object[props[0]] < 0) {
      object[props[0]] = 0;
    }
    if (object[props[1]] < 0) {
      object[props[1]] = 0;
    }
  }

  static getMonth(date) {
    const month = date.getMonth() + 1;
    return `${month}`.length < 2 ? `0${month}` : month;
  }

  static getDay(date) {
    const day = date.getDate();
    return `${day}`.length < 2 ? `0${day}` : day;
  }

  static getShortDate(date) {
    return `${this.getMonth(date)}-${this.getDay(date)}`;
  }

  static getFullDate(date) {
    return `${date.getFullYear()}-${this.getMonth(date)}-${this.getDay(date)}`;
  }

  static getCurrentDate() {
    const date = new Date();
    const month = this.getMonth(date);
    const day = this.getDay(date);
    return `${date.getFullYear()}-${month}-${day}`;
  }

  static capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static swapArrayElements(arr, indexA, indexB) {
    const temp = arr[indexA];
    arr[indexA] = arr[indexB];
    arr[indexB] = temp;
    return arr;
  }
}
